import './index.css'

import K from '../../assets/K.svg'
import E from '../../assets/E.svg'
import S from '../../assets/S.svg'

const HeaderLogo = () => {

  return (
    <div className="header_logo">
	  <img src={K} alt='' />
	  <img src={E} alt='' />
	  <img src={K} alt='' />
	  <img src={S} alt='' />
	  <div className="pos">POS</div>  
    </div>
  );
}

export default HeaderLogo
